import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ac25625"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "animate-spin",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  className: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  strokeWidth: "4"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  className: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

interface ButtonProps {
  isLoading?: boolean;
  isDisabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonComponent',
  props: {
    isLoading: { type: Boolean },
    isDisabled: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props;




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: props.isLoading || props.isDisabled,
    class: _normalizeClass(["btn", { 'btn--disabled': props.isLoading || props.isDisabled }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    (props.isLoading)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})